import { migrateTextModel } from "js/elements/base/TextElement";
import { _ } from "js/vendor";
import * as geom from "js/core/utilities/geom";
import { ds } from "js/core/models/dataService";
import { BaseElement } from "js/elements/base/BaseElement";
import { TextElement } from "js/elements/base/TextElement";
import { HorizontalAlignType, ContentBlockType } from "common/constants";

/*
    TextGroup consists of a title textElement and an optional body textElement layed out vertically

    options:
        showBody: whether the body text is optional. set to TRUE to force display of a body placeholder and prevent deletion of body
        autoWidth: passes the autoWidth option through to the child title and body textElements

        title and body options will be passed through to appropriate child textElement
 */

export class TextGroup extends BaseElement {
    get showTitle() {
        return true;
    }

    get showBody() {
        if (this.body && ds.selection.element == this.body) return true;
        if (this.showBodyPlaceholder) return true;
        if (this.options.showBody === true) return true;
        if (this.model.body && !_.isEmpty(this.model.body.text)) return true;
        return false;
    }

    get showBodyPlaceholder() {
        return this._showBodyPlaceholder == undefined ? false : this._showBodyPlaceholder;
    }

    set showBodyPlaceholder(value) {
        this._showBodyPlaceholder = value;
    }

    get textAlign() {
        if (this.title.allowAlignment && this.model.textAlign) {
            return this.model.textAlign;
        } else {
            return this.styles.textAlign || HorizontalAlignType.LEFT;
        }
    }

    get scaleTextToFit() {
        return this.options.scaleTextToFit == undefined ? false : this.options.scaleTextToFit;
    }

    get minHeight() {
        return this.title.styles.fontSize + (this.showBody ? this.body.styles.fontSize : 0);
    }

    get showAddButton() {
        return this.options.showAddButton === undefined ? true : this.options.showAddButton;
    }

    _build() {
        this.title = this.addElement("title", () => TextGroupTitle, Object.assign({
            singleLine: true,
            autoHeight: true,
            allowStyling: true,
            autoWidth: this.options.autoWidth,
            blockType: ContentBlockType.TITLE
        }, this.options.title));
        if (this.showBody) {
            this.body = this.addElement("body", () => TextGroupBody, Object.assign({
                autoHeight: true,
                allowStyling: true,
                autoWidth: this.options.autoWidth,
                blockType: ContentBlockType.BODY
            }, this.options.body));
        }
    }

    _migrate_5() {
        this.model.title = migrateTextModel(this.model.title);
        this.model.body = migrateTextModel(this.model.body);
    }

    // _migrate_8() {
    //     super._migrate_8();
    //     if (this.model.body && !this.model.body.text) {
    //         this.model.body = {
    //             text: this.model.body
    //         };
    //     }
    // }

    _calcProps(props, options) {
        let { size, children, styles } = props;

        let items = [this.title];
        this.title.styles.textAlign = options.textAlign || this.textAlign;

        if (this.showBody) {
            this.body.styles.textAlign = options.textAlign || this.textAlign;
            items.push(this.body);
        }

        const layouter = this.getLayouter(items, size);
        layouter.distributeVertically({
            horizontalAlign: options.textAlign || this.textAlign,
            itemOptions: {
                forceTextScale: options.forceTextScale || 1,
                autoWidth: options.autoWidth,
                autoHeight: options.autoHeight
            }
        });
        this.isTextFit = items.every(item => item.isTextFit !== false);

        return { size: layouter.size };
    }
}

class TextGroupTitle extends TextElement {
}

class TextGroupBody extends TextElement {
}

